import React, {Component, Fragment} from 'react'
import {connect} from 'react-redux'

//compomemts
import ReactHtmlParser from 'react-html-parser';
import {getFullMediaUrl} from "../../../../app/static_func";
import CountUp from 'react-countup';
import { InView }   from 'react-intersection-observer';

//assets
import './statistics.scss'
import manHoldingKey from 'assets/icons/man_holding_key.svg';
import peepsGrade from 'assets/icons/peeps_grade.svg';

class Statistics extends Component{
    constructor(props){
        super(props);

        this.state = {
            inView: false
        }

        this.handleInView = this.handleInView.bind(this);
        this.getStats = this.getStats.bind(this);
    }

    handleInView(inView){
        this.setState({inView:inView});
    }

    getStats(){
        const easyBuy = this.props.easyBuy;
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';
        const statistics = [];

        if (easyBuy.length > 0) {
            easyBuy.forEach((item, index) => {
                statistics.push(<InView as='div' className="statContainer" key={index} treshold={1}
                                        onChange={(inView) => this.handleInView(inView)}>
                    {isLaptopOrDesktop &&
                    <img className='stateLogo' src={getFullMediaUrl(item.image.path)} alt={item.image.alt}/>
                    }
                    <div className={"statHeader " + (this.state.inView ? 'in' : '')}>
                        {this.state.inView &&
                        <CountUp start={0} end={parseInt(item['running-number'])} suffix={ReactHtmlParser(item['running-number-prefix'])} duration={3}  delay={1} redraw={true}/>
                        }
                    </div>
                    <div className="divider"/>
                    <div className="para">{ReactHtmlParser(item.description)}</div>
                </InView>)
            });
        }

        return statistics;
    }

    render(){
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';

        return(
            <section className="statistics">
                <div className="statisticsContainer">
                    <div className='topBanner'>
                        {isLaptopOrDesktop &&
                        <img src={manHoldingKey} alt='person' className='personImg'/>
                        }
                        <div className='titleContainer'>
                            <p className="topPara">{this.props.text['statistics_top_para']}</p>
                            <div className="topDivider"></div>
                            <h2 className="title">{this.props.text['statistics_title']}</h2>
                        </div>
                        {isLaptopOrDesktop &&
                        <img src={peepsGrade} alt='logo' className='peepsImg'/>
                        }
                    </div>
                    {!isLaptopOrDesktop &&
                    <Fragment>
                        <div className="blocksContainer">
                            {this.getStats()}
                        </div>
                    </Fragment>
                    }

                    {isLaptopOrDesktop &&
                        <div className='rowContainer'>
                            {this.getStats()}
                        </div>
                    }
                </div>
            </section>
        )
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        easyBuy: store.config.EasyBuy,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {

    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Statistics);